// extracted by mini-css-extract-plugin
export default {"container":"style_container__fIDYX","btn":"style_btn__1l5cC","icon":"style_icon__WnvoA","name":"style_name__bThvV","suffix":"style_suffix__zvVIY"};